<template>
  <div class="appnewspage">
    <h3 class="title">#PCG News</h3>
    <h5 class="heading-text">Latest insights and news from the experts at PCG.</h5>
    <div class="container row">
      <div v-for="news in news_array" v-bind:key="news.id" class="post col-md-6" v-bind:style="{ 'background-image': 'url(' + news.image + ')' }">
        <div class="post_info">
            <div class="post_date">{{news.post_time}}</div>
            <div class="post_desc">{{news.post_title}}</div>
            <router-link :to="news.link" class="readmore">Read Story</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      wpData: wpData,
      close_link: '',
      news_array: []
    }
  },
  mounted() {
    this.close_link = this.wpData.template_directory_uri + "/spa/assets/images/closeIcon.png";
    let router = this.$route;
    this.wpData.pcgnews.forEach(element => {
      var post_date = new Date(element.post_date);
      var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
      var news = {id: element.ID, image: element.featured_image, post_time: months[parseInt(post_date.getMonth())] + " " + post_date.getDate() + ", " + post_date.getFullYear(), post_title: element.post_title, post_desc: element.post_content, link: "/news/"+element.ID}
      this.news_array.push(news);
    });
    console.log(this.news_array);
    $(document).ready(function(){
      $(".appnewspage .post").each(function(){
        var bottom_of_object = $(this).position().top + $(this).height();
        var bottom_of_window = $(window).scrollTop() + $(window).height();
        $(this).addClass("show");
      });
    });
    $(window).scroll(function(){
      // $(".appnewspage .post").each(function(){
      //   var bottom_of_object = $(this).position().top + $(this).outerHeight();
      //   var bottom_of_window = $(window).scrollTop() + $(window).height();
      //   if( bottom_of_window > bottom_of_object ){
      //     $(this).removeClass("hide").addClass("show");
      //   }else{
      //     $(this).removeClass("show").addClass("hide");
      //   }
      // });
    });
  },
  methods: {
      gotoMenuPage: function(event){
          alert("Event1");
      }
  }
}
</script>

<style>
.appnewspage {
  position: relative;
  width: 100%;
  min-height: calc(100vh - 132px);
  padding: 50px 0;
  background: #fff;
  color: #172c62;
}
.title{
  font-size: 42px;
  opacity: 0;
  animation-duration: 0.7s;
  animation-name: moveup;
  animation-fill-mode: forwards;
}
.heading-text{
  font-size: 22px;
  margin-bottom: 50px;
  padding:0;
  opacity: 0;
  animation-duration: 0.7s;
  animation-name: moveup;
  animation-delay: 0.5s;
  animation-fill-mode: forwards;
}
.appnewspage .row{
  margin: auto;
  justify-content: space-between;
}
.appnewspage .post{
  position: relative;
  margin-bottom: 30px;
  flex: 0 0 calc(50% - 15px);
  padding-top: 37.5%;
  opacity: 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  box-shadow: 0 0 15px rgba(0,0,0,0.3);
}
.appnewspage .post.show{
  animation-duration: 0.7s;
  animation-name: moveup;
  animation-delay: 0.8s;
  animation-fill-mode: forwards;
}
.appnewspage .post.hide{
  animation-duration: 0.7s;
  animation-name: movedown;
  animation-fill-mode: forwards;
}
.appnewspage .post img{
    width: 100%;
}
.appnewspage .post .post_info{
  text-align: left;
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  background: rgba(23, 44, 98, 0.9);
  padding: 10px 15px;
  color: #fff;
}
.appnewspage .post .post_info .post_date{
    font-size: 15px;
    margin-bottom: 5px;
}
.appnewspage .post .post_info .post_desc{
    font-size: 18px;
    font-family: brandingsemibold;
    line-height: 20px;
}
.appnewspage .post .post_info .readmore{
  width: 140px;
  height: 30px;
  font-size: 16px;
  padding: 0;
  background: none;
  color: #ffffff;
  border: 1px solid #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  text-decoration: none;
  float: right;
  transition: all 0.2s ease-in-out;
}
.appnewspage .post .post_info .readmore:hover{
  background:#ffffff;
  color: #2E55A5;
}
@media (max-width: 767px) {
  .appnewspage .post{
    flex: 0 0 100%;
    padding-top: 75%;
  }
}
@keyframes moveup {
  from {
    margin-top: 100px;
    opacity: 0;
  }

  to {
    margin-top: 0px;
    opacity: 1;
  }
}
@keyframes movedown {
  from {
    margin-top: 0;
    opacity: 1;
  }

  to {
    margin-top: 100px;
    opacity: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/AppNews.vue